// STYLES
import './styles.sass'
import 'react-lazy-load-image-component/src/effects/blur.css' // for blurring effect css
// Other Imports
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Route, Routes, useLocation } from 'react-router-dom'; // replaced BrowserRouter w' HashRouter
// import { Home, Projects, School, Art } from "./pages/index"
import { Menu } from './components/menu/menu'
import { ContactMe } from './components/contactMe/Contact-me';
import { PageRoute, routes } from './pages';
// import { PageRoute, routes } from './pages/routes';

// Main:
function Main() {
  // Scroll to top anytime page changes
  const active_page = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [active_page]);

  return (
    <div id="Main">
      <Routes>
        {routes.map((r: PageRoute) =>
          <Route path={r.path} element={<r.component/>}></Route>
        )}
      </Routes>
    </div>
  );
}

function App() {
  return (
    <div id='App'>
      <Menu/>
      <Main/>
      <ContactMe/>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);